


import barba from '@barba/core';
/**
 * Google Analyticsを更新する
 */
export default class{

	constructor(){
        const gtm = document.getElementById('is-gtm')
        if(gtm) {
            barba.hooks.afterOnce((data) => {
                if (dataLayer) {
                    dataLayer.push({
                        'newPageUrl': location.pathname,
                        event: 'pageLoaded'
                    });
                }
            });
            barba.hooks.after((data) => {
                if (dataLayer) {
                    dataLayer.push({
                        'newPageUrl': location.pathname,
                        event: 'pageLoaded'
                    });
                }
            });
        }
	}
}